import React, { useState, useEffect } from 'react';
import { Select, Button, Spin, Tooltip, Icon } from 'antd';

import Grid from '@material-ui/core/Grid';
import TextEvents from 'app/components/TextEvents';
import WorkCycleEvaluationTableContainer from 'app/containers/WorkCycleEvaluationTableContainer';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCommunicationsDispatch, workCycleEvaluationClear } from 'app/actions/WorkCycleActions';
import {
    getListSubdirectionEvaluationData,
    getListContractEvaluationData,
    getListWorkEvaluationData,
    getListFrontEvaluationData,
    getListEmployeeEvaluationData,
    getListTestEvaluationData,
    getListCommunicationProgramData,
    getCommunicationDispatchFilter
} from 'app/reducers';


import { employeeById } from 'app/reducers';
import ApiService from 'app/services/ApiService';

const { Option } = Select;

const SelectItem = (name = [], value) => {
    let x = name[value]

    return typeof x !== 'undefined' && x !== null ? x.map((c, i) => <Option key={c}>{c}</Option>) : (x === null ? <Option disabled key={'cargando valores'}>No existen valores..</Option> : <Option key={'cargando'}>Cargando valores..</Option>);

}

export default function WorkCycleEvaluationForm(props) {
    let communicationDispatchFilter = useSelector(getCommunicationDispatchFilter);

    const classes = props.classes;
    const dispatch = useDispatch();

    const [subdirec, setSubdirect] = useState([]);
    const [contract, setContract] = useState([]);
    const [front, setFront] = useState([]);
    const [work, setWork] = useState([]);
    const [name, setName] = useState([]);
    const [cpname, setCPName] = useState([]);
    const [testId, setTestId] = useState([]);
    const [externalEmployee, setExternalEmployee] = useState('');
    const [percnota, setPercnota] = useState([]);
    const userSubdir = useSelector(employeeById);
    const listSubdirectionEvaluationData = useSelector(getListSubdirectionEvaluationData)
    const listContractEvaluationData = useSelector(getListContractEvaluationData)
    const listWorkEvaluationData = useSelector(getListWorkEvaluationData)
    const listCommunicationProgramData = useSelector(getListCommunicationProgramData)
    const listFrontEvaluationData = useSelector(getListFrontEvaluationData)
    const listEmployeeEvaluationData = useSelector(getListEmployeeEvaluationData)
    const listTestEvaluationData = useSelector(getListTestEvaluationData)
    const [collapse, setCollapse] = useState(true);

    const data = {
        CommunicationProgramId: cpname.length > 0 ? cpname[0].join('|') : '',
        ContractId: contract.length > 0 ? contract[0].join('|') : '',
        ColaboradorId: name.length > 0 ? name[0].join('|') : '',
        FrontId: front.length > 0 ? front[0].join('|') : '',
        limit: props.pagination.pageSize,
        offset: (0 * props.pagination.pageSize),
        sortColumn: Object.keys(props.sorter).length > 0 ? props.sorter.field : '',
        sortDir: Object.keys(props.sorter).length > 0 ? props.sorter.order === 'ascend' ? 'ASC' : 'DESC' : '',
        // StatusName: status,
        SubdirectionId: subdirec.length > 0 ? subdirec[0].join('|') : '',
        WorkId: work.length > 0 ? work[0].join('|') : '',
        TestId: testId.length > 0 ? testId[0].join('|') : '',
        ExternalEmployee: externalEmployee,
        Pernocta: percnota.length > 0 ? percnota[0].join('|') : '',
    }

    const search = () => {
        dispatch(workCycleEvaluationClear());
        dispatch(fetchCommunicationsDispatch((props.userData.IdCompany == null ? props.userData.UserId : props.userData.IdCompany), data));
        props.setFormData(data)
    }

    const toExport = async () => {
        await ApiService.ExportCommunicationDispatch(userSubdir.employeeId, {
            SubdirectionId: String(userSubdir.idSubdirection),
            ...data
        })
            .then(
                result => {
                    const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    downloadFile(blob, 'EvaluacionCicloTrabajo.xlsx');
                },
                error => {
                    // eslint-disable-next-line no-throw-literal
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    }

    const onClickCTM = () => {
        props.setVisible(true)
        props.setIdCommunication(props.selectedRows[0].idCommunication);
        props.setRowData(props.selectedRows[0])
        props.setVisibleEvaluationCTMultiple(true)
    }

    const downloadFile = (blob, fileName) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.append(link);
        link.click();
        link.remove();
        window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
    };


    const onChangeData = (value, field) => {
        switch (field) {
            case 'idSubdirection':
                setSubdirect([value])
                break;
            case 'contractName':
                setContract([value])
                break;
            case 'ot':
                setWork([value])
                break;
            case 'communicationProgramName':
                setCPName([value])
                break;
            case 'frontName':
                setFront([value])
                break;
            case 'employee':
                if (value.includes('N/A')) {
                    setExternalEmployee('N/A')
                    value.splice(value.indexOf('N/A'), 1)
                } else { setExternalEmployee('') }
                setName([value])
                break;
            case 'test':
                setTestId([value])
                break;
            case 'percnota':
                setPercnota([value])
                break;
            default:
                break;
        }


    }

    const removeDuplicates = (originalArray, prop) => {
        var newArray = [];
        var lookupObject = {};

        for (var i in originalArray) {
            lookupObject[originalArray[i][prop]] = originalArray[i];
        }

        for (i in lookupObject) {
            newArray.push(lookupObject[i]);
        }
        return newArray;
    }

    return (
        <WorkCycleEvaluationTableContainer userData={props.userData}>
            {(params) => {
                return (
                    <div>
                        {userSubdir !== undefined ?
                            <div>
                                <div hidden={collapse}>
                                    <Grid container direction='row'>
                                        <Grid item xs={6}>
                                            <TextEvents
                                                text='Subdirección'
                                                color='darker'
                                                size='label'
                                                weight='medium'
                                            />
                                            <Select
                                                mode="multiple"
                                                placeholder="Subdirección de servicios petroleros"
                                                style={props.styles.inputSelect}
                                                onChange={(v) => onChangeData(v, 'idSubdirection')}
                                            >
                                                {
                                                    listSubdirectionEvaluationData.length !== 0 ?

                                                        removeDuplicates(listSubdirectionEvaluationData, 'idSubdirection').map((x) => {
                                                            return (
                                                                <Select.Option key={String(x.idSubdirection)} value={(String(x.idSubdirection))}>
                                                                    {x.subdirectionName}
                                                                </Select.Option>
                                                            )
                                                        })

                                                        :
                                                        null
                                                }
                                            </Select>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextEvents
                                                text='Contrato'
                                                color='darker'
                                                size='label'
                                                weight='medium'
                                            />
                                            <Select
                                                showSearch
                                                optionFilterProp="children"
                                                mode='multiple'
                                                style={{ ...props.styles.fullWidth, ...props.styles.smallBottomMargin }}
                                                placeholder='Selecciona contrato'
                                                onChange={(v) => onChangeData(v, 'contractName')}
                                            >
                                                {
                                                    listContractEvaluationData.length !== 0 ?

                                                        removeDuplicates(listContractEvaluationData, 'idContract').map((x) => {
                                                            return (
                                                                <Select.Option key={String(x.idContract)} value={(String(x.idContract))}>
                                                                    {x.contractName}
                                                                </Select.Option>
                                                            )
                                                        })

                                                        :
                                                        null
                                                }
                                            </Select>
                                        </Grid>
                                    </Grid>

                                    <Grid container direction='row'>
                                        <Grid item xs={6}>
                                            <TextEvents
                                                text='Orden de trabajo'
                                                color='darker'
                                                size='label'
                                                weight='medium'
                                            />
                                            <Select
                                                mode='multiple'
                                                showSearch
                                                optionFilterProp='children'
                                                style={props.styles.inputSelect}
                                                placeholder='Selecciona orden de trabajo'
                                                onChange={(v) => onChangeData(v, 'ot')}
                                            >
                                                {
                                                    listWorkEvaluationData.length !== 0 ?

                                                        removeDuplicates(listWorkEvaluationData, 'idWork').map((x) => {
                                                            return (
                                                                <Select.Option key={String(x.idWork)} value={(String(x.idWork))}>
                                                                    {x.workName}
                                                                </Select.Option>
                                                            )
                                                        })

                                                        :
                                                        null
                                                }
                                            </Select>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextEvents
                                                text='Programa de comunicación'
                                                color='darker'
                                                size='label'
                                                weight='medium'
                                            />
                                            <Select
                                                mode='multiple'
                                                showSearch
                                                optionFilterProp='children'
                                                style={{ ...props.styles.fullWidth, ...props.styles.smallBottomMargin }}
                                                placeholder='Selecciona programa de comunicación'
                                                onChange={(v) => onChangeData(v, 'communicationProgramName')}
                                            >
                                                {
                                                    listCommunicationProgramData.length !== 0 ?

                                                        removeDuplicates(listCommunicationProgramData, 'idCommunicationProgram').map((x) => {
                                                            return (
                                                                <Select.Option key={String(x.idCommunicationProgram)} value={(String(x.idCommunicationProgram))}>
                                                                    {x.communicationProgramName}
                                                                </Select.Option>
                                                            )
                                                        })

                                                        :
                                                        null
                                                }
                                            </Select>
                                        </Grid>
                                    </Grid>

                                    <Grid container direction='row'>
                                        <Grid item xs={6}>
                                            <TextEvents
                                                text='Frente'
                                                color='darker'
                                                size='label'
                                                weight='medium'
                                            />
                                            <Select

                                                showSearch
                                                optionFilterProp="children"
                                                mode='multiple'
                                                style={{ ...props.styles.inputSelect, ...props.styles.smallBottomMargin }}
                                                placeholder='Selecciona Frente'
                                                onChange={(v) => onChangeData(v, 'frontName')}
                                            >

                                                {
                                                    listFrontEvaluationData.length !== 0 ?

                                                        removeDuplicates(listFrontEvaluationData, 'idFront').map((x) => {
                                                            return (
                                                                <Select.Option key={String(x.idFront)} value={(String(x.idFront))}>
                                                                    {x.frontName}
                                                                </Select.Option>
                                                            )
                                                        })

                                                        :
                                                        null
                                                }
                                            </Select>
                                        </Grid>

                                        <Grid item xs={6}>
                                            <TextEvents
                                                text='Nombre o Ficha'
                                                color='darker'
                                                size='label'
                                                weight='medium'
                                            />
                                            <Select

                                                showSearch
                                                optionFilterProp="children"
                                                mode='multiple'
                                                style={{ ...props.styles.inputSelect, ...props.styles.smallBottomMargin }}
                                                placeholder='Nombre o ficha'
                                                onChange={(v) => onChangeData(v, 'employee')}
                                            >
                                                {
                                                    listEmployeeEvaluationData.length !== 0 ?

                                                        removeDuplicates(listEmployeeEvaluationData, 'employeeId').map((x) => {
                                                            return (
                                                                <Select.Option key={String(x.employeeId)} value={(String(x.employeeId))}>
                                                                    {x.employeeName}
                                                                </Select.Option>
                                                            )
                                                        })

                                                        :
                                                        null
                                                }
                                            </Select>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextEvents
                                                text='Evaluación de Ciclo de Trabajo'
                                                color='darker'
                                                size='label'
                                                weight='medium'
                                            />
                                            <Select

                                                showSearch
                                                optionFilterProp="children"
                                                mode='multiple'
                                                style={{ ...props.styles.inputSelect, ...props.styles.smallBottomMargin }}
                                                placeholder='Selecciona Evaluación de Ciclo de Trabajo'
                                                onChange={(v) => onChangeData(v, 'test')}
                                            >
                                                {
                                                    listTestEvaluationData.length !== 0 ?

                                                        removeDuplicates(listTestEvaluationData, 'idTest').map((x) => {
                                                            return (
                                                                <Select.Option key={String(x.idTest)} value={(String(x.idTest))}>
                                                                    {x.testTitle}
                                                                </Select.Option>
                                                            )
                                                        })

                                                        :
                                                        null
                                                }
                                            </Select>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextEvents
                                                text='Percnota'
                                                color='darker'
                                                size='label'
                                                weight='medium'
                                            />
                                            <Select

                                                showSearch
                                                optionFilterProp="children"
                                                mode='multiple'
                                                style={{ ...props.styles.inputSelect, ...props.styles.smallBottomMargin }}
                                                placeholder='Selecciona Percnota'
                                                onChange={(v) => onChangeData(v, 'percnota')}
                                            >
                                                {SelectItem(communicationDispatchFilter, 'pernocta')}
                                            </Select>
                                        </Grid>
                                    </Grid>
                                </div>

                                <div className={classes.container} style={props.styles.baseVerticalMargin}>
                                    {
                                        collapse ?
                                            <Tooltip title={"Mostrar filtro"}>
                                                <Button
                                                    className={classes.button}
                                                    variant="contained"
                                                    type="link"
                                                    onClick={() => setCollapse(false)}
                                                >
                                                    <Icon type="down" />
                                                </Button>
                                            </Tooltip> :
                                            <Tooltip title={"Ocultar filtro"}>
                                                <Button
                                                    className={classes.button}
                                                    variant="contained"
                                                    type="link"
                                                    onClick={() => setCollapse(true)}
                                                >
                                                    <Icon type="up" />
                                                </Button>
                                            </Tooltip>
                                    }
                                    <Button
                                        className={classes.button}
                                        variant='contained'
                                        type='primary'
                                        onClick={() => search()}
                                    >
                                        Buscar
                                    </Button>
                                    <Button
                                        className={classes.button}
                                        variant='contained'
                                        type='primary'
                                        onClick={toExport}
                                    >
                                        Exportar
                                    </Button>
                                    <Button
                                        disabled={props.disableCTMultiple}
                                        className={classes.button}
                                        variant='contained'
                                        type='primary'
                                        onClick={() => onClickCTM()}
                                    >
                                        Evaluar CT múltiple
                                    </Button>
                                </div>
                            </div> : <div className={props.classes.spin}><Spin /></div>}
                    </div>
                )
            }}
        </WorkCycleEvaluationTableContainer>
    );

}